













import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { filterUrl } from '~/assets/filters/url'
import { ILinkItem } from '~/assets/interfaces/navigation'
import MixinGeneral from '~/assets/mixins/general'
import { CONFIG_LAYOUT_HEADER_INFO_MENU_API } from '~/assets/config/api-path'

@Component({
  filters: {
    filterUrl,
  },
})
export default class ComponentQuickAccessMenu extends mixins(MixinGeneral) {
  @Prop({ type: Boolean }) readonly white!: boolean

  private items: ILinkItem[] | [] = []

  private async getMenu() {
    this.items =
      (await this.$axios.$get(CONFIG_LAYOUT_HEADER_INFO_MENU_API)) || null
  }

  private async mounted() {
    await this.getMenu()
  }

  private get colorType() {
    return {
      [this.$style.white]: this.white,
      [this.$style.default]: !this.white,
    }
  }
}
